//判断Ajax请求是否失败
const isFailed = (response) => {
    let code = response.data.result_code
    return code !== 0
}

//转换日期格式
const dateToString = function(dateS) {
    if (dateS) {
        let date = new Date(dateS)
        let Y = date.getFullYear()
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        let H = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours())
        let Min = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes())
        let S = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
        return `${Y}-${M}-${D} ${H}:${Min}:${S}`
    }
    return ''
}

//出生年月日
const bornDate = function(row, col) {
    if (row[col.property]) {
        let date = new Date(row[col.property])
        let Y = date.getFullYear()
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        return `${Y}年${M}月${D}日`
    }
    return ''
}

const dateToStringShort = function(dateS) {
    return dateToString(dateS).substr(0, 10)
}

const fmtTime = function(row, col) {
    let val = row[col.property]
    return dateToString(val)
}

const fmtTimeShort = function(row, col) {
    if (row) {
        let val = row[col.property]
        return dateToStringShort(val)
    }
}

const getRecentDateRange = function(recentSomeDays) {
    let dateArr = []
    let today = new Date();
    for (let i = 1; i <= recentSomeDays; i++) {
        let temp = new Date()
        let beforeToday = temp.setDate(today.getDate() - i)
        dateArr.push(this.dateToStringShort(beforeToday))
    }
    return dateArr.reverse()
}

const fmtImgUrl = function(ImgUrl) {
    let url = 'http://stls.iot-expeed.com/pic/';
    if (ImgUrl) {
        if (/http:\/\/znmj.p99.store/.test(ImgUrl)) {
            return ImgUrl
        } else {
            return url + ImgUrl
        }
    }
}

const catchError = function(errRes, errorText) {
    if (errorText) {
        this.$message.error(errorText)
    } else {
        if (errRes == 'undefined') {
            return false
        }
        if (errRes.result_code != 2) {
            this.$message.error(errRes.result_msg.toString())
        } else { //  没有权限
            console.log(errRes.result_msg)
        }
    }
}
const levelObj = function(level) {
    let obj = {
        1: '省级',
        2: '市级',
        3: '派出所',
        4: '自然村',
        5: '警务室',
    }
    return obj[level]
}

const transformCoord = function(lat, lon, fromTo) {

    // longitude: "121.635414"
    // latitude: "29.884407"

    let GPS = {
        PI: 3.14159265358979324,
        x_pi: 3.14159265358979324 * 3000.0 / 180.0,
        delta: function(lat, lon) {
            var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
            var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
            var dLat = this.transformLat(lon - 105.0, lat - 35.0);
            var dLon = this.transformLon(lon - 105.0, lat - 35.0);
            var radLat = lat / 180.0 * this.PI;
            var magic = Math.sin(radLat);
            magic = 1 - ee * magic * magic;
            var sqrtMagic = Math.sqrt(magic);
            dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI);
            dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI);
            return { 'lat': dLat, 'lon': dLon };
        },

        //WGS-84 to GCJ-02
        gcj_encrypt: function(wgsLat, wgsLon) {
            if (this.outOfChina(wgsLat, wgsLon))
                return { 'lat': wgsLat, 'lon': wgsLon };

            var d = this.delta(wgsLat, wgsLon);
            return { 'lat': wgsLat + d.lat, 'lon': wgsLon + d.lon };
        },
        //GCJ-02 to WGS-84
        gcj_decrypt: function(gcjLat, gcjLon) {
            if (this.outOfChina(gcjLat, gcjLon))
                return { 'lat': gcjLat, 'lon': gcjLon };

            var d = this.delta(gcjLat, gcjLon);
            return { 'lat': gcjLat - d.lat, 'lon': gcjLon - d.lon };
        },
        //GCJ-02 to WGS-84 exactly
        gcj_decrypt_exact: function(gcjLat, gcjLon) {
            var initDelta = 0.01;
            var threshold = 0.000000001;
            var dLat = initDelta,
                dLon = initDelta;
            var mLat = gcjLat - dLat,
                mLon = gcjLon - dLon;
            var pLat = gcjLat + dLat,
                pLon = gcjLon + dLon;
            var wgsLat, wgsLon, i = 0;
            while (1) {
                wgsLat = (mLat + pLat) / 2;
                wgsLon = (mLon + pLon) / 2;
                var tmp = this.gcj_encrypt(wgsLat, wgsLon)
                dLat = tmp.lat - gcjLat;
                dLon = tmp.lon - gcjLon;
                if ((Math.abs(dLat) < threshold) && (Math.abs(dLon) < threshold))
                    break;

                if (dLat > 0) pLat = wgsLat;
                else mLat = wgsLat;
                if (dLon > 0) pLon = wgsLon;
                else mLon = wgsLon;

                if (++i > 10000) break;
            }
            //console.log(i);
            return { 'lat': wgsLat, 'lon': wgsLon };
        },
        //GCJ-02 to BD-09
        bd_encrypt: function(gcjLat, gcjLon) {
            var x = gcjLon,
                y = gcjLat;
            var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * this.x_pi);
            var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * this.x_pi);
            var bdLon = z * Math.cos(theta) + 0.0065;
            var bdLat = z * Math.sin(theta) + 0.006;
            return { 'lat': bdLat, 'lon': bdLon };
        },
        //BD-09 to GCJ-02
        bd_decrypt: function(bdLat, bdLon) {
            var x = bdLon - 0.0065,
                y = bdLat - 0.006;
            var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * this.x_pi);
            var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * this.x_pi);
            var gcjLon = z * Math.cos(theta);
            var gcjLat = z * Math.sin(theta);
            return { 'lat': gcjLat, 'lon': gcjLon };
        },
        //WGS-84 to Web mercator
        //mercatorLat -> y mercatorLon -> x
        mercator_encrypt: function(wgsLat, wgsLon) {
            var x = wgsLon * 20037508.34 / 180.;
            var y = Math.log(Math.tan((90. + wgsLat) * this.PI / 360.)) / (this.PI / 180.);
            y = y * 20037508.34 / 180.;
            return { 'lat': y, 'lon': x };
        },
        // Web mercator to WGS-84
        // mercatorLat -> y mercatorLon -> x
        mercator_decrypt: function(mercatorLat, mercatorLon) {
            var x = mercatorLon / 20037508.34 * 180.;
            var y = mercatorLat / 20037508.34 * 180.;
            y = 180 / this.PI * (2 * Math.atan(Math.exp(y * this.PI / 180.)) - this.PI / 2);
            return { 'lat': y, 'lon': x };
        },
        // two point's distance
        distance: function(latA, lonA, latB, lonB) {
            var earthR = 6371000.;
            var x = Math.cos(latA * this.PI / 180.) * Math.cos(latB * this.PI / 180.) * Math.cos((lonA - lonB) * this.PI / 180);
            var y = Math.sin(latA * this.PI / 180.) * Math.sin(latB * this.PI / 180.);
            var s = x + y;
            if (s > 1) s = 1;
            if (s < -1) s = -1;
            var alpha = Math.acos(s);
            var distance = alpha * earthR;
            return distance;
        },
        outOfChina: function(lat, lon) {
            if (lon < 72.004 || lon > 137.8347)
                return true;
            if (lat < 0.8293 || lat > 55.8271)
                return true;
            return false;
        },
        transformLat: function(x, y) {
            var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
            ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
            ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
            ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
            return ret;
        },
        transformLon: function(x, y) {
            var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
            ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
            ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
            ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
            return ret;
        }
    };

    if (fromTo == 'BaiduToGPS') { //  百度 转 GPS
        let BaiduToGaode = GPS.bd_decrypt(lat, lon)
        let GaodeToGPS = GPS.gcj_decrypt_exact(BaiduToGaode.lat, BaiduToGaode.lon)
        return GaodeToGPS
    }
    if (fromTo == 'GPSToBaidu') { // GPS 转 百度
        let GPSToGaode = GPS.gcj_encrypt(lat, lon);
        let GaodeToBaidu = GPS.bd_encrypt(GPSToGaode.lat, GPSToGaode.lon)
        return GaodeToBaidu
    }
}


const FormatterType = function(row, col) {
    let str = ''
    let num = parseInt(row.type)
    switch (num) {
        case 0:
            str = '未知';
            break;
        case 85:
            str = '内开';
            break;
        case 51:
            str = '内锁';
            break;
        case 68:
            str = '外锁';
            break;
        case 102:
            str = '外开';
            break;
    }
    return str;
}
const FormatterWay = function(row, col) {
    let str = ''
    let num = parseInt(row.way)
    switch (num) {
        case 0:
            str = '未知';
            break;
        case 17:
            str = '身份证开门';
            break;
        case 34:
            str = '输密码开门';
            break;
        case 51:
            str = '钥匙开门';
            break;
        case 68:
            str = '蓝牙开门';
            break;
    }
    return str;
}

export default {
    isFailed,
    dateToString,
    dateToStringShort,
    fmtTime,
    fmtTimeShort,
    getRecentDateRange,
    bornDate,
    fmtImgUrl,
    catchError,
    levelObj,
    transformCoord,
    FormatterType,
    FormatterWay
}


// WEBPACK FOOTER //
// ./src/util/index.js